// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperSelector-cls1___9da8f1bba62dc6d131f{/*!*/}.PaperSelector-cls2___4494517b59c3935146d{display:flex;flex-direction:column;grid-gap:4px;gap:4px;padding:8px;cursor:pointer}.PaperSelector-cls2___4494517b59c3935146d.PaperSelector-selected__caec32f92eb4aec545a0{background-color:#afccfc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperSelector-cls1___9da8f1bba62dc6d131f",
	"cls2": "PaperSelector-cls2___4494517b59c3935146d PaperSelector-cls1___9da8f1bba62dc6d131f",
	"selected": "PaperSelector-selected__caec32f92eb4aec545a0"
};
export default ___CSS_LOADER_EXPORT___;
